import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useState } from 'react';
import { mapArrayDropdownOptions } from 'utils/funciones';

const useBuscarEstadosByCodigoPostal = () => {
  const [estados, setEstados] = useState([]);
  const buscarEstadosByCodigoPostal = async (codigoPostal) => {
    const Data = {
      datosCotizador: {
        prodCodigo: 'TRAVELBTA',
        cotPasoCodigo: 'estados-by-codigo-postal',
        codPostal: codigoPostal,
      },
    };
    const res = await ApiKeyFetch.instance().post(URLS_PHP_7.emision.datosEmision, Data);
    const data = res?.catalogo?.estados?.map(mapArrayDropdownOptions) || [];
    setEstados([...data]);
    return data;
  };

  return { buscarEstadosByCodigoPostal, estados, setEstados };
};

export default useBuscarEstadosByCodigoPostal;
